module.exports = __webpack_public_path__ + "img/loading02.f2fcc9e7.png";